import { iSupplier } from "@sdk/suppliers/supplier-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { suppliersDefaultQueryConfig } from "./suppliers-default-query";

export const {
  slice: SuppliersSlice,
  reducers: SuppliersSliceReducer,
  actions: {
    setEntityQueryResults: setSuppliersQueryResults,
    setEntity: setSupplier,
    setEntities: setSuppliers,
    patchEntity: patchSupplier,
    addNewEntity: addNewSupplier,
    setEntityFetchingStatus: setSupplierFetchingStatus,
    setEntitiesFetchingStatus: setSuppliersFetchingStatus,
    setEntityFailedStatus: setSupplierFailedStatus,
    setEntityQueryError: setSuppliersQueryError,
    resetQuery: resetSuppliersQuery,
    setQueryList: setSupplierQueryList,
  },
} = CreateEntitySlice<iSupplier>({
  sliceName: "suppliers",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...suppliersDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
